import { Button } from "@/components/ui/button";
import { CredenzaBody, CredenzaClose, CredenzaFooter } from "@/components/ui/credenza";
import { useScopedI18n } from "@/locales/client";
import { CheckCircle } from "lucide-react";

export function Success({ paymentMethod: _paymentMethod }: { paymentMethod: "bank" | "crypto" }) {
    const t = useScopedI18n("paymentDialogs.common.success");

    return (
        <>
            <CredenzaBody className="my-8 flex flex-col items-center">
                <div className="flex items-center justify-center">
                    <CheckCircle className="size-8" />
                </div>
                <h2 className="mt-4 text-center font-bold text-xl">{t("title")}</h2>
                <div className="mt-2 max-w-sm text-balance text-center text-muted-foreground text-sm">
                    {t("wallet.description")}
                </div>
            </CredenzaBody>

            <CredenzaFooter>
                <CredenzaClose asChild>
                    <Button>{t("buttons.close")}</Button>
                </CredenzaClose>
            </CredenzaFooter>
        </>
    );
}
